// extracted by mini-css-extract-plugin
export default {"wrapper":"AddUserButton_wrapper__FD34h","form":"AddUserButton_form__xaKYR","button-wrapper":"AddUserButton_button-wrapper__j6BxK","spinner":"AddUserButton_spinner__0U6Dr"};